import { config } from 'react-spring';

export const slowDropConfig = {
  from: { y: -10 },
  to: { y: 0 },
  config: config.slow
};
